import { useState } from "react";
import { fileUrl } from "@/lib/api";

export function ImageGallery({ images = [], title }) {
  const [active, setActive] = useState(0);
  const current = images[active];
  return (
    <>
      <div className="border-2 border-black bg-[#F2F2F2] aspect-[4/3] overflow-hidden" data-testid="listing-image-main">
        {current
          ? <img src={fileUrl(current)} alt={title} className="w-full h-full object-contain" />
          : <div className="w-full h-full flex items-center justify-center font-mono-data text-xs uppercase text-gray-500">NO IMAGE</div>}
      </div>
      {images.length > 1 && (
        <div className="grid grid-cols-6 gap-2 mt-2" data-testid="listing-thumbnails">
          {images.map((img, i) => (
            <button key={img} onClick={() => setActive(i)} className={`aspect-square border-2 ${active === i ? "border-[#0000EE]" : "border-black"} overflow-hidden`}>
              <img src={fileUrl(img)} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </>
  );
}
